export const PAYROLL_PERCENTAGE_FIELDS = [
  {
    percentageField: 'ctcHRAPercentage',
    amountField: 'ctcHRA',
    label: 'HRA'
  },
  {
    percentageField: 'ctcSpecialAllowancePercentage',
    amountField: 'ctcSpecialAllowance',
    label: 'Special Allowance'
  },
  {
    percentageField: 'ctcTravelAllowancePercentage',
    amountField: 'ctcTravelAllowance',
    label: 'Travel Allowance'
  },
  {
    percentageField: 'ctcITAllowancePercentage',
    amountField: 'ctcITAllowance',
    label: 'IT Allowance'
  }
];

export const PAYROLL_PERCENTAGE_INPUT_FIELDS = PAYROLL_PERCENTAGE_FIELDS.map(
  ({ percentageField }) => percentageField
);

export const INITIAL_PAYROLL_PERCENTAGES = PAYROLL_PERCENTAGE_FIELDS.reduce(
  (accumulator, { percentageField }) => ({
    ...accumulator,
    [percentageField]: ''
  }),
  {}
);

const toNumber = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const formatAmount = (value) => {
  const rounded = Math.round(value * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
};

export const derivePayrollValues = (formData) => {
  const basic = toNumber(formData.ctcBasic);
  const updates = {};
  let totalCtc = basic ?? 0;

  PAYROLL_PERCENTAGE_FIELDS.forEach(({ percentageField, amountField }) => {
    const percentage = toNumber(formData[percentageField]);

    if (basic == null || percentage == null) {
      updates[amountField] = '';
      return;
    }

    const amount = (basic * percentage) / 100;
    updates[amountField] = formatAmount(amount);
    totalCtc += amount;
  });

  updates.payScale = basic == null ? '' : formatAmount(totalCtc);
  return updates;
};

export const formatCurrencyPreview = (value) => {
  const numericValue = toNumber(value);
  if (numericValue == null) return 'Auto-calculated';
  return `Rs ${formatAmount(numericValue)}`;
};